import * as types from "../action/ActionType";
import { INVOICE_LIST_INITIAL} from "../store/InitialStore";

export default function InvoiceListSelectReducer(state = INVOICE_LIST_INITIAL, action) {
  const { type, payload } = action;
  switch (type) {
    case types.INVOICE_LIST_SELECT:
      return {
        ...state, // Spread the existing state 
        ...payload, // Merge with the new payload
      };
    default:
      return state;
  }
}
